import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import '../../Layout/Box/Box.js';
import { Inline } from '../../Layout/Inline/Inline.js';
import '../../Layout/Stack/Stack.js';
import MarketplaceLogo from './treatwell-marketplace-logo.inline.svg.js';
import styles from './MarketplaceHeader.module.css.js';

const MarketplaceHeader = ({ onLogoClick, logoHref, logoAriaLabel, 'data-cy': dataCy = 'MarketplaceLogo', }) => {
    return (jsxRuntimeExports.jsx(Inline, { justify: "start", "data-cy": dataCy, children: jsxRuntimeExports.jsx("a", { href: logoHref, onClick: onLogoClick, "aria-label": logoAriaLabel, className: styles.link, children: jsxRuntimeExports.jsx("div", { className: styles.logo, children: jsxRuntimeExports.jsx(MarketplaceLogo, {}) }) }) }));
};
const HeaderContainer = ({ children, 'data-cy': dataCy, }) => {
    return (jsxRuntimeExports.jsx("header", { className: styles.headerContainer, "data-cy": dataCy, children: children }));
};

export { HeaderContainer, MarketplaceHeader, MarketplaceLogo };
//# sourceMappingURL=MarketplaceHeader.js.map
